import { Navigate } from 'react-router-dom'
import useAuth from 'src/hooks/useAuth'
import { SUPERADMIN_EMAILS } from 'src/utils/onboarding'

const SuperadminGuard = ({ children }: { children: JSX.Element }) => {
    const { user } = useAuth()
    if (!SUPERADMIN_EMAILS.includes(user?.email)) return <Navigate to='/dashboard' replace />
    return children
}

export default SuperadminGuard
